// NOTICE: KAPTION-INTEGRATION
import { frontendURL } from '../../../helper/URLHelper';

const AiStudioIndex = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-studio'),
    name: 'ai_studio_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: AiStudioIndex,
  },
];
